import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieNoticeDialogComponent } from 'projects/shared/lib/components/shared/base/cookie/notice-dialog/cookie-notice-dialog.component';

@Component({
  selector: 'app-cookie-notice-dialog',
  imports: [CommonModule],
  templateUrl: './cookie-notice-dialog.component.html',
  styleUrls: ['./cookie-notice-dialog.component.scss']
})
export class CookieNoticeDialogMHComponent extends CookieNoticeDialogComponent { }
